export default __webpack_public_path__ + "static/media/banner_ihelp2.d9630f63.jpg";